/*
 *Commonly used keys
 * like success; failure; access token etc.
 *
 * Add or remove variables according to your requirement
 */

export const NAVIGATION_PERSISTENCE_KEY = '@idp/navigation-state';
export const ACCESS_KEY = '@idp/access-token';
export const AUTHENTICATION_INFO_KEY = '@idp/isAuthenticated';
export const TOKEN_INFO_KEY = '@idp/auth';
export const USER_INFO_KEY = '@idp/userinfo';
export const SUCCESS_KEY = 'success';
export const FAILURE_KEY = 'failure';
export const ERROR_KEY = 'error';
export const ADD_KEY = 'add';
export const EDIT_KEY = 'edit';
export const REGISTER_KEY = 'register';
export const VIEW_KEY = 'view';
export const VIEW_ONLY_KEY = 'view-only';
export const LANGUAGE_KEY = 'language';
export const MAIN_MENU_KEY = 'main_menu';
export const SUB_MENU_KEY = 'sub_menu';
export const NUMERIC_KEYBOARD = 'numeric';
export const LOCATION_KEY = '@address/location';
export const POSTAL_ADDRESS_KEY = '@address/postal';
export const ORG_SUPER_ADMIN = 'Org Super Admin';
export const ORG_EMPLOYEE = 'Org Employee';
export const ORG_ADMIN = 'Org Admin';
export const APP_SUPER_ADMIN = 'App Super Admin';

// designations
export const DEVELOPER = 'Developer';
export const TESTER = 'Tester';
export const BUSINESS_ANALYST = 'Business Analyst';
export const PROJECT_MANAGER = 'Project Manager';
export const UI_UX_DESIGNER = 'UI/UX Designer';
export const DEV_OPS = 'DevOps Engineer';
